import { useBillModalLauncher } from '~/components/BillModal/hooks/useBillModalLauncher';
import { useGlobalBillClient } from '~/hooks/useGlobalBillClient';
import { getGroupedAgreementOptions } from '~/pages/GlobalBillingHub/GlobalBillingHub.utils';
import { useFetchRelationshipSummaries } from '~/pages/GlobalBillingHub/hooks/useFetchRelationshipSummaries';
import { resolveBillClientRoute } from './useBillClient.utils';
export const useBillClient = (clientId)=>{
    const { summaries } = useFetchRelationshipSummaries({
        refreshOnHookMount: true
    });
    const { openBillClient } = useBillModalLauncher();
    const { openGlobalBillModalForClient } = useGlobalBillClient();
    return ()=>{
        const grouped = getGroupedAgreementOptions(summaries, clientId);
        const route = resolveBillClientRoute(grouped);
        if (route.kind === 'direct') {
            openBillClient(route.relationshipId);
            return;
        }
        openGlobalBillModalForClient(clientId);
    };
};
